import { Component, Input } from '@angular/core';

@Component({
  selector: 'bw-background',
  styles: [
      `img.bg {
        /* Set rules to fill background */
        // min-height: 100%;
        min-width: 1024px;
        /* Set up proportionate scaling */
        // width: 100%;
        // height: auto;
        /* Set up positioning */
        position: fixed;
        top: 0;
        left: 0;
      }
      
      @media screen and (max-width: 420px) {
        /* Specific to this particular image */
        img.bg {
          left: 50%;
          margin-left: -290px;
          /* 50% */
        }
      }

      @media screen and (min-width: 421px) {
        /* Specific to this particular image */
        img.bg {
          min-height: 100%;
        }
      }`
  ],
  template: `<img class="bg animated fadeIn" src="{{image}}"/>`,
})
export class BackgroundComponent {
    @Input() image: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/ui/background/background.component.ts